exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pack-content[data-v-4c7a8283] {\n  position: relative;\n  height: 100%;\n  margin: 0 50px;\n  overflow: auto;\n}\n.card-item[data-v-4c7a8283] {\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n.card-item .bg-cover[data-v-4c7a8283],\n.card-item .card-inner[data-v-4c7a8283] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n}\n.card-item .bg-cover.active[data-v-4c7a8283] {\n  opacity: 0.7;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.28.11@css-loader?{"minimize":false,"sourceMap":false}!./~/_vue-loader@11.3.4@vue-loader/lib/style-compiler?{"id":"data-v-4c7a8283","scoped":true,"hasInlineConfig":true}!./~/_less-loader@4.0.5@less-loader/dist/cjs.js?{"sourceMap":false}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=styles&index=0!./src/views/pack/index.vue
// module id = 718
// module chunks = 1